import {_, React, withStyles, StyledProps, CentricTheme, classNames} from '@api'
import { Divider } from '@material-ui/core'
import {DrawerTitleLocation} from 'centric-ui-components';
import * as css from './DrawerHeader.css'

const styles = (theme: CentricTheme) => ({
  drawerHeaderContent: {
    display:        'flex',
    justifyContent: 'center',
    alignItems:     'center',
    maxHeight:'100%',
    height: 'auto'
  }
})

interface MyProps extends StyledProps {
  variant?: string
  titleLocation?: DrawerTitleLocation
  showDivider?: boolean
}

@(withStyles as any)(styles)
export class DrawerHeader extends React.Component<MyProps> {
  static defaultProps = {
    titleLocation: 'inline',
    showDivider: false
  }

  render() {
    const { props: {children, classes, titleLocation, className, showDivider}}= this;

    return (
      <div data-type='DrawerHeader' data-location={titleLocation} className={classNames(className, css.root)}>
        <div className={classes.drawerHeaderContent}>
          {children}
        </div>
        {showDivider && <Divider/>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/DrawerHeader.tsx